import { render } from "./PopUpSharePlaceFile.vue?vue&type=template&id=efa7d5e6&scoped=true"
import script from "./PopUpSharePlaceFile.vue?vue&type=script&lang=js"
export * from "./PopUpSharePlaceFile.vue?vue&type=script&lang=js"

import "./PopUpSharePlaceFile.vue?vue&type=style&index=0&id=efa7d5e6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efa7d5e6"]])

export default __exports__